<template>
  <div class="viewcontent" v-if="translations.pay">
    <Alert type="warning" :list="errors.pay"/>

    <h1>{{ translations.pay.title_success }}</h1>

    <img :src="require('@/assets/icon/shopping_cart.svg')" />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  export default {
    name: 'Pay Success',
    components: {
      Alert,
    },
    computed: {
      ...mapState(['errors', 'translations']),
    },
    methods: {
      ...mapActions(['savePay']),
    },
    async created() {
      await this.savePay({
        type: this.$route.params.type,
        payid: this.$route.params.id,
        receipt: this.$route.params.receipt,
      })
    },
  }
</script>

<style></style>
